import Modal from '../../mini/Modal'
import React from 'react'
import { P3 } from '../../styled/typography/typography'
import Button from '../../mini/Button'
import { useDispatch } from 'react-redux'
import { ModalStyles } from './styled'
import { hideModal, showModal } from '../../../actions/_modal'

const GuardianEmailAlreadyUsed = ({ response, token }) => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(hideModal())
    dispatch(showModal('CREATE_GUARDIAN_ACCOUNT', { response, token }))
  }

  return (
    <Modal
      width={472}
      height={180}
      top={55}
      background={'transparent'}
      opacity={'1'}
      boxShadow={'0 0 30px 0 rgba(0,0,0,0.07)'}
    >
      <ModalStyles>
        <div className="center">
            <P3 style={{ marginBottom: '15px' }}>
              This link is already in use for an existing Quest! account. Please create a guardian account with a different email.
            </P3>
          <hr className="line" />
          <Button
            text="Ok"
            className="quest-btn btn-a go uncap active"
            onClick={() => handleClick()}
            style={{ marginTop: '40px', width: '99px' }}
          />
        </div>
      </ModalStyles>
    </Modal>
  )
}

export default GuardianEmailAlreadyUsed
